import { EventEmitter, Input, Output, Directive } from '@angular/core';
import {QuoteRowObject} from '../../class/quote/quote-row-object';

@Directive()
export abstract class AbstractQuoteComponent {

  @Input()
  title: string;

  @Input()
  showFranchigia = false;

  @Input()
  showOptions = true;

  @Input()
  coverType: number;

  @Output()
  OnValueChange = new EventEmitter<QuoteRowObject>();

  isEditing = false;

  protected onEdit(value: boolean) {
    this.isEditing = value;
  }

  public onRowUpdated(value: QuoteRowObject) {
    this.OnValueChange.emit(value);
  }
}
